import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getFilteredTagsByWorkspaceForSubmit } from '@/modules/corporate/modules/tags/utils';
import AddWorkspaceSettingsModal from '@/modules/corporate/modules/workspaceSettings/components/AddWorkspaceSettingsModal';
import { DEFAULT_WORKSPACE_IDS } from '@/modules/corporate/modules/workspaceSettings/const';
import { EntityTagType } from '@/types/schema';

import { SurveySettingsDialogProps } from '../../types';

const WorkspaceSettings: React.FC<SurveySettingsDialogProps> = (props) => {
  const { t } = useTranslation();
  const { initialSurvey, onClose, onSubmit } = props;

  const selectedWorkspaces = useMemo(
    () => initialSurvey.subWorkspaces || DEFAULT_WORKSPACE_IDS,
    [initialSurvey.subWorkspaces],
  );

  const _onSubmit = useCallback(
    async (subWorkspaceIds: any) => {
      onSubmit({
        subWorkspaceIds,
        tags: getFilteredTagsByWorkspaceForSubmit({
          entityTags: initialSurvey.tags as EntityTagType[],
          subWorkspaceIds,
        }),
      });

      return Promise.resolve(true);
    },
    [initialSurvey.tags, onSubmit],
  );

  return (
    <AddWorkspaceSettingsModal
      contentName={t('Common:ResourceType.Survey')}
      selectedWorkspaces={selectedWorkspaces}
      onClose={onClose}
      onSubmit={_onSubmit}
    />
  );
};

export default WorkspaceSettings;
